export default __webpack_public_path__ + "static/media/headpage.8c3f0edb.jpg";